import {
  FieldSection,
  FieldSectionTitle,
  FieldsRow,
  FormContainer,
  FormPhoneField,
  FormRoleConfContext,
  FormTextField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formRoleConf } from "./Contact.formRoleConf"
import { ContactEnum, type ContactFormValues } from "./Contact.schema"

export const Contact = () => {
  const conf = useRoleConf(formRoleConf)

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Contact" />
        <FieldSection
          title="Communication"
          subtitle="A minima, renseigner l’e-mail, le téléphone fixe et le portable de l’adhérent"
        >
          <FormTextField<ContactFormValues>
            label="E-mail public"
            name={ContactEnum.EMAIL}
          />
          <FormTextField
            label="E-mail du titulaire principal"
            name={ContactEnum.PRIMARY_HOLDER_EMAIL}
          />
          <FieldsRow>
            <FormPhoneField<ContactFormValues>
              label="Portable de l'officine"
              name={ContactEnum.MOBILE}
              fullWidth
            />
            <FormPhoneField
              label="Portable du titulaire principal"
              name={ContactEnum.PRIMARY_HOLDER_PHONE}
              fullWidth
            />
          </FieldsRow>
          <FieldsRow>
            <FormPhoneField<ContactFormValues>
              label="Téléphone fixe"
              name={ContactEnum.PHONE}
              fullWidth
            />
            <FormPhoneField<ContactFormValues>
              label="Fax"
              name={ContactEnum.FAX}
              fullWidth
            />
          </FieldsRow>
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
